<template>
  <div>
    <b-row>
      <b-col class="pt-2">
        {{ totalRows }}
        {{ trans('url_link' + (totalRows > 1 ? 's' : '')).toLowerCase() }}
      </b-col>
      <b-col class="col-auto">
        <b-button size="sm" variant="secondary" @click="onRefresh" :title="trans('refresh')" :disabled="busy" v-b-tooltip.hover>
          <i class="fa fa-fw fa-redo" v-if="!busy"></i>
          <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
        </b-button>
        <b-button variant="primary" size="sm" class="ml-2" @click="onAdd">
          <i class="fa fa-fw fa-plus"></i>
        </b-button>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col>
        <b-table
          id="vimeo-urls"
          ref="table"
          class="bg-white table-row-click"
          bordered
          small
          responsive
          show-empty
          :fields="fields"
          :items="provider"
          :per-page="perPage"
          :current-page="currentPage"
          @row-clicked="onRowClick"
        >
          <template v-slot:empty>
            <p align="center">{{ trans('none') }}</p>
          </template>
          <template v-slot:cell(url)="data">
            {{ data.value }}<br/>
            <b-button variant="link" size="sm" class="p-0" v-clipboard:copy="data.value">
              <i class="fa fa-fw fa-copy"></i>
              {{ trans('copy') }}
            </b-button>
            <b-button variant="link" size="sm" class="p-0" :href="data.item.send_url">
              <i class="fa fa-fw fa-comment"></i>
              {{ trans('send') }}
            </b-button>
            <b-button variant="link" size="sm" class="p-0" :href="data.value" target="_blank">
              <i class="fa fa-fw fa-external-link-alt"></i>
              {{ trans('visit') }}
            </b-button>
          </template>
        </b-table>
        <b-pagination
          :per-page="perPage"
          :current-page="currentPage"
          :total-rows="totalRows"
          v-model="currentPage"
          aria-controls="vimeo-urls"
          align="center"
        />
      </b-col>
    </b-row>

    <vimeo-url-modal
      :organization="organization"
      :video="video"
      :vimeo_url="item"
      @saved="onRefresh"
      @deleted="onRefresh"
    ></vimeo-url-modal>
  </div>
</template>

<script>
  import VimeoUrlModal from './VimeoUrlModal'

  export default {
    props: {
      organization: Object,
      vimeo_user: Object,
      video: Object,
    },
    components: {
      VimeoUrlModal,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        busy: false,
        error: null,
        fields: [{
          key: 'name',
          label: trans('label'),
          class: 'table-row-width-200',
        }, {
          key: 'url',
          label: 'URL',
          class: 'table-row-width-200',
        }, {
          key: 'email',
          label: trans('email'),
          class: 'table-row-width-200',
        }, {
          key: 'mobile',
          label: trans('mobile'),
        }, {
          key: 'max_view_count',
          label: trans('max_view_count'),
        }, {
          key: 'expired_at',
          label: trans('expiration'),
          formatter(value) {
            return value ? moment(value).format('LL') : null
          },
        }, {
          key: 'view_count',
          label: trans('view_count'),
        }, {
          key: 'expires_in_days',
          label: trans('expires_in_days'),
          formatter(value) {
            if (!value) return null
            return value >= 0 ? value : trans('expired')
          },
        }],
        items: [],
        perPage: this.rows || 10,
        currentPage: 1,
        totalRows: 0,
        item: null,
      }
    },
    methods: {
      onRefresh() {
        this.currentPage = 1
        this.$refs.table.refresh()
      },
      onAdd() {
        this.item = null
        setTimeout(() => {
          this.$bvModal.show('vimeo-url-modal')
        }, 1)
      },
      onRowClick(item) {
        this.item = item
        setTimeout(() => {
          this.$bvModal.show('vimeo-url-modal')
        }, 1)
      },
      provider() {
        this.error = null
        this.busy = true
        let url = `/organization/${this.organization.id}/media/vimeo/${this.video.id}/url?page=${this.currentPage}&per_page=${this.perPage}`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.currentPage = response.data.current_page
          this.perPage = response.data.per_page
          this.totalRows = response.data.total
          this.items = response.data.data
          return this.items
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
          this.items = []
          return this.items
        })
      },
    },
    mounted() {
      window.vimeoUrls = this
    },
  }
</script>